export const quickFilters = [
  { id: 0, label: 'All', param: '', value: '' },
  { id: 1, label: 'Active', param: 'statusList', value: 'active' },
  { id: 2, label: 'Cleared', param: 'statusList', value: 'cleared' },
  { id: 3, label: 'Acknowledged', param: 'isAcknowledged', value: 'True' },
  { id: 4, label: 'Unacknowledged', param: 'isAcknowledged', value: 'False' },
];
